import { Theme } from '@mui/material/styles';
import { TableProps } from '@mui/material';

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
          '& .MuiTableCell-body:first-of-type': {
            paddingLeft: '8px',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: TableProps }) => ({
          borderBottom: '1px solid var(--dk-line, #E7E9EC)',
          fontSize: 12,
          padding: ownerState.size === 'medium' ? '16px 0' : '4px 5px',
        }),
        head: {
          '&:first-of-type': {
            '&:not(.checkbox)': {
              paddingLeft: '8px',
            },
          },
          padding: '12px 0',
          fontSize: '14px',
          fontWeight: 400,
          color: 'var(--dk-text-secondary, #888D96)',
          borderBottom: 'none',
          backgroundColor: 'var(--dk-bg-muted, #F3F5F6)',
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, var(--dk-bg-muted, #F3F5F6) 0%, var(--dk-bg-muted, #F3F5F6) 100%)`,
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
      },
    },
    MuiTablePagination: {
      defaultProps: {
        backIconButtonProps: {
          size: 'small',
        },
        nextIconButtonProps: {
          size: 'small',
        },
        SelectProps: {
          MenuProps: {
            MenuListProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  ...theme.typography.body2,
                },
              },
            },
          },
        },
      },

      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 64,
        },
        actions: {
          marginRight: theme.spacing(1),
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
      },
    },
  };
}
